import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { NextPage, NavigationLocation, NextPageService } from '@cvx/nextpage';
import { menuRoutes } from './app-routing.module';
import { environment } from '../environments/environment';
import { LoggedUserService } from './services/logged-user.service';
import { SpinnerComponent } from "./shared/spinner/spinner.component";

@Component({
  selector: 'app-root',
  imports: [RouterModule, NextPage, SpinnerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

  loggedInEmail: string | null = null;
  errorMessage: string | null = null;
  isLoading: boolean = false;
  NavigationLocation = NavigationLocation;
  isInGroup: boolean = false;
  assemblyDate: string = (() => {
    //const d = new Date(environment.releaseDate + 'T00:00:00');
    //return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    return environment.releaseDate;
  })();

  constructor(
    private authService: CalAngularService,
    private router: Router,
    private NP: NextPageService,
    private loggedUserService: LoggedUserService
  ) {
    this.NP.setOption('sitename', 'CemSys');
    this.NP.setOption('navigationRoutes', menuRoutes);
  }

  ngOnInit() {
    if (this.authService.isUserSignedIn()) {
      this.isLoading = true;
      this.authService.isInGroup(environment.groupName).subscribe(isInGroup => {
        if (isInGroup) {
          const account = this.authService.getAccount();
          this.loggedInEmail = account ? account.username : null;
          this.loggedUserService.setLoggedUserData(this.loggedInEmail);
          this.isInGroup = true;
        } else {
          this.router.navigate(['/no-access']);
        }
        this.isLoading = false;
      });
    } else {
      this.authService.userInitiatedSignIn();
    }
  }
}
